import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { ActionCode, Page, TLCode } from '../../common/enums';
import {
  AnchorStore,
  ApplicationStore,
  AuthenticationStore,
  BankHolidayDateStore,
  BlackPointStatusStore,
  BlackPointStore,
  DutyStore,
  LocaleStore,
  PharmacyDetailedStore,
  PharmacyStore,
  UiStore,
} from '../../store';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Tab, Tabs } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';

// import {
//   green,
//   greenDot,
//   greenPushpin,
//   icon11,
//   icon3,
//   mm20Gray,
//   red,
//   redDot,
//   redPushpin,
//   yellow,
//   yellowDot,
//   blue,
//   lightblue,
// } from '../../assets';
import MultiCalendarsForComparison from '../common/MultiCalendarsForComparison';
import styled from '@emotion/styled';
import { css } from 'emotion';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});

interface CalendarComparisonPageProps extends RouteComponentProps<{ pharmacyId: string }> {
  getPharmacyById: (id: number) => any;
  UiStore?: Instance<typeof UiStore>;
}

interface CalendarComparisonPageState {

}

@inject('PharmacyDetailedStore')
@inject('PharmacyStore')
@inject('UiStore')
@observer
class CalendarComparisonPage extends React.Component<CalendarComparisonPageProps & WithTranslateProps, CalendarComparisonPageState> {
  state = {

  };

  render(){
    const pharmacyId = this.props.UiStore!.lastSelectedPharmacy;
    return (

      // <MainSectionLayout title={TLCode.CALENDAR_COMPARISON_PAGE} >
      <MainSectionLayout>
        <Container>
          <Card className={CardStyle.toString()}>
          {/* <MultiCalendarsForComparison startingPharmacy="1" startingSecondPharmacy="2" /> */}
            <MultiCalendarsForComparison startingPharmacy={pharmacyId} startingSecondPharmacy={pharmacyId}/>
          </Card>
        </Container>
      </MainSectionLayout>

    );
  }
}

export default withTranslate(CalendarComparisonPage);